/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { B200, B400, N0, N200, N40A, N50A, N60A } from '@atlaskit/theme/colors';
import { h200, h500 } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';

import { Link } from '../Router';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BaseIcon = styled.div`
	border-radius: ${token('border.radius.100', '3px')};
	display: flex;
	width: ${token('space.300', '24px')};
	height: ${token('space.300', '24px')};
	color: ${token('elevation.surface.raised', N0)};
	margin-left: ${token('space.050', '4px')};
	margin-top: ${token('space.050', '4px')};
	margin-right: ${token('space.150', '12px')};

	span {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	svg {
		width: ${token('space.250', '20px')};
		height: ${token('space.250', '20px')};
	}

	img {
		width: ${token('space.300', '24px')};
		height: ${token('space.300', '24px')};
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlacesItem = styled.div`
	position: relative;
	border-radius: ${token('border.radius.100', '3px')};
	padding: ${token('space.150', '12px')} ${token('space.200', '16px')} ${token('space.200', '16px')}
		${token('space.150', '12px')};
	background: ${token('elevation.surface.raised', N0)};
	box-shadow: ${token('elevation.shadow.raised', `0 1px 1px ${N50A}, 0 0 1px 1px ${N40A}`)};
	transition: box-shadow 0.25s ease;
	overflow: hidden;
	display: flex;
	flex-direction: column;

	&:hover,
	&.active {
		box-shadow: ${token('elevation.shadow.overlay', `0 4px 8px -2px ${N50A}, 0 0 1px ${N60A}`)};
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Header = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-bottom: ${token('space.050', '4px')};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderIcon = styled.div`
	display: flex;
	margin-left: ${token('space.025', '2px')};
	margin-right: ${token('space.050', '4px')};
	width: ${token('space.200', '16px')};
	height: ${token('space.200', '16px')};
	color: ${token('color.icon.brand', B400)};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const HeaderTitle = styled.div`
	${h200};
	margin-top: 0px;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Content = styled.div`
	display: flex;
	align-items: center;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpaceIcon = styled(BaseIcon)`
	background: ${token('color.icon.subtle', N200)};
	display: grid;
	place-items: center;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BoardIcon = styled(BaseIcon)`
	background: ${token('color.icon.brand', B400)};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Details = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 0;
	white-space: nowrap;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PlaceLink = styled(Link)`
	${h500};
	margin-top: ${token('space.025', '2px')};
	text-overflow: ellipsis;
	overflow: hidden;

	&:focus {
		box-shadow: 0 0 0 2px ${token('color.border.focused', B200)};
		outline: none;
		border-radius: ${token('border.radius.100', '3px')};
	}
`;
